import styled from "styled-components";

export const GeneralContainer = styled.div`
  border: 1px solid ${props => props.theme.color.primary};
  border-radius: 4px;
  margin: 8px;
  overflow: hidden;
  flex: 1;
`

export const GeneralContainerTitle = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  background-color: ${props => props.theme.color.primary};
  color: #ffffff;
  padding: 8px;
`;

export const GeneralContainerBody = styled.div`
  padding: 32px;
`;